import { render, staticRenderFns } from "./LayananDetailList.vue?vue&type=template&id=861430c0&scoped=true"
import script from "./LayananDetailList.vue?vue&type=script&lang=js"
export * from "./LayananDetailList.vue?vue&type=script&lang=js"
import style0 from "./LayananDetailList.vue?vue&type=style&index=0&id=861430c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861430c0",
  null
  
)

export default component.exports